import React from 'react';

import {OETarget} from '../../../react-oe/oe-target';
import OEIconCodes from '../../../lib/oe-icon-codes';
import OEProtoCapBar from '../oe-proto-cap-bar';
import {OEDemoTargetType, OEDemoTargets, OEDemoFeatureAccess, OEDemoStartSelectionData} from './oe-demo-model';

export default class OEDemoCapBar extends React.PureComponent {

    constructor(props) {
        super(props);

        this.targetTypeMap = {
            [OEDemoTargetType.anatomy]:       {icon: OEIconCodes.demo.anatomyTarget, titleId: 'cap_bar_target_title_anatomy'},
            [OEDemoTargetType.histology]:     {icon: OEIconCodes.demo.histologyTarget, titleId: 'cap_bar_target_title_histology'},
            [OEDemoTargetType.ophthalmology]: {icon: OEIconCodes.demo.ophthalmologyTarget, titleId: 'cap_bar_target_title_ophthalmology'},
            [OEDemoTargetType.orthopedic]:    {icon: OEIconCodes.demo.orthopedicTarget, titleId: 'cap_bar_target_title_orthopedic'},
            [OEDemoTargetType.toxicology]:    {icon: OEIconCodes.demo.toxicologyTarget, titleId: 'cap_bar_target_title_toxicology'},
            [OEDemoTargetType.visceral]:      {icon: OEIconCodes.demo.visceralTarget, titleId: 'cap_bar_target_title_visceral'},
            // [OEDemoTargetType.cell]:        {icon: OEIconCodes.demo.cellTarget, titleId: 'cap_bar_target_title_cell'},
            [OETarget.effigosExplorerHelp]: {target: OETarget.effigosExplorerHelp, icon: OEIconCodes.help, noTargetTypeBarEntry: true, titleId: 'target_menu_effigosExplorerHelp'}
        };
    }

    render()    {
        //let targetTypes = [OEDemoTargetType.orthopedic, OEDemoTargetType.visceral, OEDemoTargetType.anatomy, OEDemoTargetType.histology, OEDemoTargetType.cell, OETarget.effigosExplorerHelp];

        let targetTypes = OEDemoStartSelectionData.chooseModules().map(module => module.id);
        targetTypes.push(OETarget.effigosExplorerHelp);

        return (
            <OEProtoCapBar
                {...this.props}
                targetTypes={targetTypes}
                targetTypeMap={this.targetTypeMap}
                versionTargets={OEDemoTargets}
                featureAccess={OEDemoFeatureAccess}
                startSelectionData={OEDemoStartSelectionData}
            />
        );
    }
}